<template>
  <div class="max-w-5xl bg-mtg-dark-cyan py-[30px] px-[60px] rounded-[5px] mx-auto">
    <div class="font-primary font-extrabold text-[21px] text-white text-center uppercase pb-[15px]">
      {{ package_filter_title_1 }}
    </div>
    <div class="font-primary font-light text-[14px] text-white text-center pb-[30px]">{{ package_filter_title_2 }}</div>
    <form ref="formObserver">
      <div class="grid grid-cols-12 gap-x-0 md:gap-x-[15px]">
        <div class="col-span-12 md:col-span-6 xl:col-span-3">
          <div class="flex items-center min-h-[40px] bg-mtg-light-grey border-[1px] rounded-[5px] mb-[15px]" x-data="{ isFocused : false }" x-bind:class="isFocused ? 'border-mtg-light-green' : 'border-mtg-medium-grey'">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-mtg-medium-grey ml-[15px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"/>
            </svg>
            <input type="text" class="w-full h-full font-primary font-light text-[14px] text-mtg-medium-grey bg-mtg-light-grey border-none rounded-none focus:outline-none focus-within:outline-none" name="title" v-model="title" v-bind:placeholder="package_filter_placeholder_1" x-bind:class="isFocused ? 'placeholder-mtg-medium-blue' : 'placeholder-mtg-medium-grey'" x-on:focusin="isFocused = true" x-on:focusout="isFocused = false">
          </div>
        </div>
        <div class="col-span-12 md:col-span-6 xl:col-span-3">
          <div class="flex items-center min-h-[40px] bg-mtg-light-grey border-[1px] rounded-[5px] mb-[15px]" x-data="{ isFocused : false }" x-bind:class="isFocused ? 'border-mtg-light-green' : 'border-mtg-medium-grey'">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-mtg-medium-grey ml-[15px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/>
            </svg>
            <input type="text" class="w-full h-full font-primary font-light text-[14px] text-mtg-medium-grey bg-mtg-light-grey border-none rounded-none focus:outline-none focus-within:outline-none" name="destination" v-model="destination" v-bind:placeholder="package_filter_placeholder_2" x-bind:class="isFocused ? 'placeholder-mtg-medium-blue' : 'placeholder-mtg-medium-grey'" x-on:focusin="isFocused = true" x-on:focusout="isFocused = false">
          </div>
        </div>
        <div class="col-span-12 md:col-span-6 xl:col-span-3">
          <div class="flex items-center min-h-[40px] bg-mtg-light-grey border-[1px] rounded-[5px] mb-[15px]" x-data="{ isFocused : false }" x-bind:class="isFocused ? 'border-mtg-light-green' : 'border-mtg-medium-grey'">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-mtg-medium-grey ml-[15px] mr-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
            <select class="w-full h-full font-primary font-light text-[14px] text-mtg-medium-grey bg-mtg-light-grey border-none rounded-none focus:outline-none focus-within:outline-none" name="length" v-model="length" x-bind:class="isFocused ? 'placeholder-mtg-medium-blue' : 'placeholder-mtg-medium-grey'" x-on:focusin="isFocused = true" x-on:focusout="isFocused = false">
              <option selected value="" v-html="package_filter_placeholder_3"></option>
              <option v-for="option in package_filter_options_3" v-bind:value="option.value" v-html="option.name"></option>
            </select>
          </div>
        </div>
        <div class="col-span-12 md:col-span-6 xl:col-span-3">
          <div class="flex items-center min-h-[40px] bg-mtg-light-grey border-[1px] rounded-[5px] mb-[15px]" x-data="{ isFocused : false }" x-bind:class="isFocused ? 'border-mtg-light-green' : 'border-mtg-medium-grey'">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-mtg-medium-grey ml-[15px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z" clip-rule="evenodd"/>
            </svg>
            <select class="w-full h-full font-primary font-light text-[14px] text-mtg-medium-grey bg-mtg-light-grey border-none rounded-none focus:outline-none focus-within:outline-none" name="category" v-model="category" x-bind:class="isFocused ? 'placeholder-mtg-medium-blue' : 'placeholder-mtg-medium-grey'" x-on:focusin="isFocused = true" x-on:focusout="isFocused = false">
              <option selected value="" v-html="package_filter_placeholder_4"></option>
              <option v-for="option in package_filter_categories" v-bind:value="option.term_id" v-html="option.name"></option>
            </select>
          </div>
        </div>
        <v-date-picker class="col-span-12 md:col-span-6" v-model="range" mode="date" is-range v-bind:model-config="modelConfig" v-bind:masks="masks">
          <template v-slot="{ inputValue, inputEvents }">
            <div class="flex items-center min-h-[40px] bg-mtg-light-grey border-[1px] rounded-[5px] mb-[15px]" x-data="{ isFocused : false }" x-bind:class="isFocused ? 'border-mtg-light-green' : 'border-mtg-medium-grey'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-mtg-medium-grey ml-[15px] mr-[5px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <input type="text" class="w-full h-full font-primary font-light text-[14px] text-mtg-medium-grey bg-mtg-light-grey border-none rounded-none focus:outline-none focus-within:outline-none" name="date_from" id="date_from" v-on="inputEvents.start" v-bind:value="inputValue.start" v-bind:placeholder="package_filter_placeholder_5" x-bind:class="isFocused ? 'placeholder-mtg-medium-blue' : 'placeholder-mtg-medium-grey'" x-on:focusin="isFocused = true" x-on:focusout="isFocused = false">
            </div>
          </template>
        </v-date-picker>
        <v-date-picker class="col-span-12 md:col-span-6" v-model="range" mode="date" is-range v-bind:model-config="modelConfig" v-bind:masks="masks">
          <template v-slot="{ inputValue, inputEvents }">
            <div class="flex items-center min-h-[40px] bg-mtg-light-grey border-[1px] rounded-[5px] mb-[15px]" x-data="{ isFocused : false }" x-bind:class="isFocused ? 'border-mtg-light-green' : 'border-mtg-medium-grey'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-[25px] h-[25px] text-mtg-medium-grey ml-[15px] mr-[5px]" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
              </svg>
              <input type="text" class="w-full h-full font-primary font-light text-[14px] text-mtg-medium-grey bg-mtg-light-grey border-none rounded-none focus:outline-none focus-within:outline-none" name="date_to" id="date_to" v-on="inputEvents.end" v-bind:value="inputValue.end" v-bind:placeholder="package_filter_placeholder_6" x-bind:class="isFocused ? 'placeholder-mtg-medium-blue' : 'placeholder-mtg-medium-grey'" x-on:focusin="isFocused = true" x-on:focusout="isFocused = false">
            </div>
          </template>
        </v-date-picker>
        <div class="col-span-12 flex items-center justify-end">
          <div class="flex items-center justify-center">
            <div v-on:click="reset" class="inline-flex items-center justify-center text-white bg-transparent border-white py-[10px] px-[30px] border-[1px] rounded-[30px] my-[5px] mx-[10px] cursor-pointer transition-all ease-in-out duration-300 hover:text-mtg-medium-blue hover:bg-mtg-light-green hover:border-mtg-medium-blue">
              <span class="font-primary text-[15px]">{{ package_filter_label_2 }}</span>
            </div>
          </div>
          <div class="flex items-center justify-center">
            <div v-on:click="submit" class="inline-flex items-center justify-center text-white bg-transparent border-white py-[10px] px-[30px] border-[1px] rounded-[30px] my-[5px] mx-[10px] cursor-pointer transition-all ease-in-out duration-300 hover:text-mtg-medium-blue hover:bg-mtg-light-green hover:border-mtg-medium-blue">
              <span class="font-primary text-[15px]">{{ package_filter_label_1 }}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'PackageFilterForm',
  data () {
    return {
      package_filter_title_1: window.package_archive_script_data.package_filter_title_1,
      package_filter_title_2: window.package_archive_script_data.package_filter_title_2,
      package_filter_placeholder_1: window.package_archive_script_data.package_filter_placeholder_1,
      package_filter_placeholder_2: window.package_archive_script_data.package_filter_placeholder_2,
      package_filter_placeholder_3: window.package_archive_script_data.package_filter_placeholder_3,
      package_filter_placeholder_4: window.package_archive_script_data.package_filter_placeholder_4,
      package_filter_placeholder_5: window.package_archive_script_data.package_filter_placeholder_5,
      package_filter_placeholder_6: window.package_archive_script_data.package_filter_placeholder_6,
      package_filter_label_1: window.package_archive_script_data.package_filter_label_1,
      package_filter_label_2: window.package_archive_script_data.package_filter_label_2,
      package_filter_options_3: _.sortBy(window.package_archive_script_data.package_filter_options_3, [function (length) {
        return length.value;
      }]),
      package_filter_categories: _.sortBy(window.package_archive_script_data.package_filter_categories, [function (category) {
        return category.name;
      }]),
      package_filter_parameters: window.package_archive_script_data.package_filter_parameters,
      package_filter_has_parameters: window.package_archive_script_data.package_filter_has_parameters,
      package_filter_archive_link: window.package_archive_script_data.package_filter_archive_link,
      title: '',
      destination: '',
      length: '',
      category: '',
      date_from: '',
      date_to: '',
      range: {
        start: '',
        end: '',
        // start: (new Date()).toLocaleDateString('en-GB'),
        // end: (new Date()).toLocaleDateString('en-GB'),
      },
      modelConfig: {
        type: 'string',
        mask: 'DD/MM/YYYY',
      },
      masks: {
        input: 'DD/MM/YYYY',
      },
    };
  },
  watch: {
    'range.start': function (val) {
      this.date_from = val;
    },
    'range.end': function (val) {
      this.date_to = val;
    },
  },
  methods: {
    removeLocalStorageItems () {
      localStorage.removeItem('title');
      localStorage.removeItem('destination');
      localStorage.removeItem('length');
      localStorage.removeItem('category');
      localStorage.removeItem('date_from');
      localStorage.removeItem('date_to');
    },
    setLocalStorageItems () {
      localStorage.setItem('title', this.title);
      localStorage.setItem('destination', this.destination);
      localStorage.setItem('length', this.length);
      localStorage.setItem('category', this.category);
      localStorage.setItem('date_from', this.range.start);
      localStorage.setItem('date_to', this.range.end);
    },
    reset () {
      this.removeLocalStorageItems();
      window.location.href = this.package_filter_archive_link;
    },
    submit () {
      this.setLocalStorageItems();
      this.$refs.formObserver.submit();
    },
  },
  mounted () {
    if (localStorage.getItem('title')) {
      this.title = localStorage.getItem('title');
    }

    if (localStorage.getItem('destination')) {
      this.destination = localStorage.getItem('destination');
    }

    if (localStorage.getItem('length')) {
      this.length = localStorage.getItem('length');
    }

    if (localStorage.getItem('category')) {
      this.category = localStorage.getItem('category');
    }

    if (this.package_filter_has_parameters) {
      if (this.package_filter_parameters.title) {
        this.title = this.package_filter_parameters.title;
      }

      if (this.package_filter_parameters.destination) {
        this.destination = this.package_filter_parameters.destination;
      }

      if (this.package_filter_parameters.length) {
        this.length = this.package_filter_parameters.length;
      }

      if (this.package_filter_parameters.category) {
        this.category = this.package_filter_parameters.category;
      }
    }
  },
  beforeMount () {
    if (localStorage.getItem('date_from')) {
      let date_from = localStorage.getItem('date_from').split('/');
      this.range.start = new Date(date_from[2], date_from[1] - 1, date_from[0]);
    }

    if (localStorage.getItem('date_to')) {
      let date_to = localStorage.getItem('date_to').split('/');
      this.range.end = new Date(date_to[2], date_to[1] - 1, date_to[0]);
    }

    if (this.package_filter_has_parameters) {
      if (this.package_filter_parameters.date_from) {
        let date_from = this.package_filter_parameters.date_from.split('/');
        this.range.start = new Date(date_from[2], date_from[1] - 1, date_from[0]);
      }

      if (this.package_filter_parameters.date_to) {
        let date_to = this.package_filter_parameters.date_to.split('/');
        this.range.end = new Date(date_to[2], date_to[1] - 1, date_to[0]);
      }
    }

    if (!this.package_filter_has_parameters) {
      this.removeLocalStorageItems();
    }
  }
};
</script>
<style scoped>
</style>
